import { SupportAgentRounded } from "@mui/icons-material";
import { Box, Button, CircularProgress, Tooltip } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { useTranslation } from "react-i18next";
import useTodooDaySupport from "src/hooks/useTodooDaySupport";

const OnlineSupport = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { available, loading, openSupport } = useTodooDaySupport();

  if (!available) {
    return null;
  }

  const handleOpen = async () => {
    try {
      await openSupport();
    } catch (error) {
      enqueueSnackbar(
        error?.response?.data?.message ||
          error?.message ||
          t("Soporte no disponible"),
        { variant: "error" },
      );
    }
  };

  return (
    <Tooltip title={t("Soporte en l�nea")}>
      <Button
        color="inherit"
        onClick={handleOpen}
        disabled={loading}
        aria-label={t("Soporte en l�nea")}
        startIcon={
          loading ? (
            <CircularProgress color="inherit" size={18} />
          ) : (
            <SupportAgentRounded fontSize="small" />
          )
        }
        sx={{
          minWidth: { xs: 36, md: "auto" },
          px: { xs: 0.75, md: 1.25 },
          textTransform: "none",
          "& .MuiButton-startIcon": { mx: { xs: 0, md: 0.5 } },
        }}
      >
        <Box component="span" sx={{ display: { xs: "none", md: "inline" } }}>
          {t("Soporte")}
        </Box>
      </Button>
    </Tooltip>
  );
};

export default OnlineSupport;
